import { FileDto } from '../../file';

export interface NewsProfileDto {
  avatar: FileDto | null;
  name: string | null;
  profession: string | null;
  userId: string;
}
